import wallpapers from '../data/wallpapers.json';
import colors from '../data/desktop-colors.json';
import type { DesktopColor, Wallpaper, WallpaperFit } from '../types/content';

const catalog = wallpapers as Wallpaper[];
const colorCatalog = colors as DesktopColor[];

export const FITS: { id: WallpaperFit; title: string }[] = [
  { id: 'center', title: 'Center' },
  { id: 'tile', title: 'Tile' },
  { id: 'stretch', title: 'Stretch' },
  { id: 'fill', title: 'Fill' },
];

export function wallpaperById(id: string | undefined): Wallpaper {
  return catalog.find((w) => w.id === id) ?? catalog.find((w) => w.id === 'supes') ?? catalog[0];
}

export function colorByHex(hex: string | undefined): DesktopColor {
  return colorCatalog.find((c) => c.hex.toLowerCase() === (hex ?? '').toLowerCase()) ?? colorCatalog[0];
}

export function allWallpapers(): Wallpaper[] {
  return catalog;
}

export function allColors(): DesktopColor[] {
  return colorCatalog;
}

export function isFit(v: string): v is WallpaperFit {
  return FITS.some((f) => f.id === v);
}

export function applyDesktopBackground(
  el: HTMLElement,
  opts: { wallpaperId: string; wallpaperFit: WallpaperFit; desktopColor: string },
): void {
  const paper = wallpaperById(opts.wallpaperId);
  el.style.backgroundColor = opts.desktopColor;
  if (!paper.src) {
    el.style.backgroundImage = 'none';
    return;
  }
  el.style.backgroundImage = `url(${paper.src})`;
  el.style.imageRendering = paper.pixelated ? 'pixelated' : 'auto';
  if (opts.wallpaperFit === 'center') {
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundPosition = 'center';
    el.style.backgroundSize = 'auto';
  } else if (opts.wallpaperFit === 'tile') {
    el.style.backgroundRepeat = 'repeat';
    el.style.backgroundPosition = '0 0';
    el.style.backgroundSize = 'auto';
  } else if (opts.wallpaperFit === 'stretch') {
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundPosition = 'center';
    el.style.backgroundSize = '100% 100%';
  } else {
    el.style.backgroundRepeat = 'no-repeat';
    el.style.backgroundPosition = 'center';
    el.style.backgroundSize = 'cover';
  }
}
